import { NgOptimizedImage } from '@angular/common'
import { Component } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NgOptimizedImage, SvgIconComponent, TranslatePipe],
  templateUrl: './footer.component.html',
})
export class FooterComponent {}
